import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useLayoutEffect,
} from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import api from "../../api";
import nodeApi from "../../nodeApi";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import useDynamicPageSize from "../../useDynamicPageSize";
import Footer from "../../Footer";
import { toast, ToastContainer } from "react-toastify";
import {
  HeaderFilterProvider,
  useHeaderFilters,
} from "../../context/HeaderFilterContext";
import CommonSelect from "../../core/common/commonSelect";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Modal } from "bootstrap";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { encryptQuery, decryptQuery } from "../../utils/encryption";
import { Moment } from "moment";
import moment from "moment";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import Password from "antd/es/input/Password";
import Button from "antd/es/button";
import { useFilterData } from "../../context/FilterContext";

type Option = { label: string; value: any };

type EmployeeType = {
  id: number;
  name: string;
  eId: any;
  phoneNumber: number;
  joinDate: string;
  birthDate: string;
  imageUrl?: string;
  designation: { title: string };
  isOnboardingComplete: number;
  isExitComplete: number;
  status: string;
};
type ModalMode = "add" | "edit";
type EmployeeFiltersProps = {
  searchTerm: string;
  onSearchTermChange: (val: string) => void;
  designationOptions: Option[];
  selectedDesignation: any;
  onDesignationChange: (opt: Option | null) => void;
  statusOptions: Option[];
  selectedStatus: any;
  onStatusChange: (opt: Option | null) => void;
  onAdd: () => void;
  onResetFilters: () => void;
};

interface EmployeeFiltersQuery {
  searchTerm: string | null;
  currentPage?: number;
  selectedDesignation?: any;
  selectedStatus?: any;
}
dayjs.extend(isSameOrAfter);
const EmployeeFilters: React.FC<EmployeeFiltersProps> = ({
  searchTerm,
  onSearchTermChange,
  designationOptions,
  selectedDesignation,
  onDesignationChange,
  statusOptions,
  selectedStatus,
  onStatusChange,
  onAdd,
  onResetFilters, // New prop
}) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  // Close on outside click or ESC key
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        showMobileFilters &&
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setShowMobileFilters(false);
      }
    };

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") setShowMobileFilters(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [showMobileFilters]);

  return (
    <div className="upper-absolute-class">
      {/* Mobile View */}
      <div className="d-lg-none ">
        <div
          className="d-flex align-items-center gap-2 "
          style={{ paddingRight: "12px" }}
        >
          {(selectedDesignation || selectedStatus || searchTerm) && (
            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={onResetFilters}
            >
              <i className="ti ti-refresh" />
            </button>
          )}

          <div className="holiday-flex">
            <input
              type="text"
              className="form-control search-size"
              placeholder="Search Employee"
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
            />
          </div>

          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={() => setShowMobileFilters(!showMobileFilters)}
          >
            <i className="ti ti-filter" />
          </button>
          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={onAdd}
          >
            <i className="ti ti-circle-plus" />
          </button>
        </div>

        {/* Mobile Filter Dropdown */}

        {showMobileFilters && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "103px",
              zIndex: 1050,
            }}
          >
            <div
              ref={modalRef}
              className="bg-white shadow rounded p-3 mt-2 z-3 filter_select "
              style={{ width: "90%", maxWidth: "400px" }}
            >
              <div className="d-flex flex-column gap-2">
                <CommonSelect
                  // isFullWidth={true}
                  // isOpenModal = {true}
                  className="select"
                  options={designationOptions}
                  value={
                    designationOptions.find(
                      (o) => o.value === selectedDesignation
                    ) ?? undefined
                  }
                  forceFullWidth={true}
                  onChange={(selected) => {
                    onDesignationChange(selected);
                    setShowMobileFilters(false); // Close modal
                  }}
                />
                <CommonSelect
                  className="select"
                  // isFullWidth={true}
                  // isOpenModal = {true}
                  forceFullWidth={true}
                  options={statusOptions}
                  value={
                    statusOptions.find((o) => o.value === selectedStatus) ??
                    undefined
                  }
                  onChange={(selected) => {
                    onStatusChange(selected);
                    setShowMobileFilters(false); // Close modal
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Desktop View */}
      <div className="">
        <div className="Employee-filters d-flex align-items-center flex-wrap gap-2 d-none d-sm-none d-md-none d-lg-flex ">
          <div className="d-flex align-items-center gap-2">
            {(selectedDesignation || selectedStatus || searchTerm) && (
              <button
                className="btn btn-outline-primary add_btn_size"
                onClick={onResetFilters}
              >
                <i className="ti ti-refresh" />
              </button>
            )}

            <input
              type="text"
              className="form-control search-size"
              placeholder="Search…"
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
            />
            <CommonSelect
              className="select"
              options={designationOptions}
              //   isHeight ={false}
              // isOpenModal = {true}
              value={
                designationOptions.find(
                  (o) => o.value === selectedDesignation
                ) ?? undefined
              }
              onChange={onDesignationChange}
            />
            <CommonSelect
              className="select"
              options={statusOptions}
              // isOpenModal = {true}
              //   isHeight ={false}
              value={
                statusOptions.find((o) => o.value === selectedStatus) ??
                undefined
              }
              onChange={onStatusChange}
            />

            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={onAdd}
            >
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Debounce hook
function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const h = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(h);
  }, [value, delay]);
  return debounced;
}

const Employees: React.FC = () => {
  const { setFilters } = useHeaderFilters();
  const [filtersReady, setFiltersReady] = useState(false);
  const userInitiatedSearchRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isInitialFetch = useRef(true);
  const { filtersData } = useFilterData();
  const [loading, setLoading] = useState(true);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [isSaving, setIsSaving] = useState(false);

  //   const skipQuerySyncRef = useRef(false);

  // Pagination & data
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = useDynamicPageSize();
  const [totalItems, setTotalItems] = useState(0);

  useLayoutEffect(() => {
    if (pageSize === 0) return;
    const calculateHeight = () => {
      const baseOffset = 285;
      const extraOffset = window.innerWidth <= 991 ? -65 : -80;
      const fixedOffset = baseOffset + extraOffset;

      const newHeight = window.innerHeight - fixedOffset;

      console.log("Calculated table height:", newHeight);
      console.log("fixedOffset:", fixedOffset);
      console.log("window.innerHeight:", window.innerHeight);
      console.log("pageSize:", pageSize);
      console.log("totalItems:", totalItems);

      setTableHeight(newHeight);
    };

    calculateHeight(); // initial + on totalItems change
    window.addEventListener("resize", calculateHeight);

    return () => window.removeEventListener("resize", calculateHeight);
  }, [totalItems, pageSize]);

  const [designationsList, setDesignationsList] = useState<EmployeeType[]>([]);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});

  // Filters
  const [designationOptions, setDesignationOptions] = useState<Option[]>([]);
  const [selectedDesignation, setSelectedDesignation] = useState<any>("");
  const [modalDesignationOptions, setModalDesignationOptions] = useState<
    Option[]
  >([]);
  const [modalStatusOptions, setModalStatusOptions] = useState<Option[]>([]);

  const isExitStatus = (status: any) => {
    const label = modalStatusOptions.find((opt) => opt.value === status)?.label;
    return ["Notice Period","Released", "Terminated"].includes(label || "");
  };

  const [statusOptions, setStatusOptions] = useState<Option[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [reportingHeadOptions, setReportingHeadOptions] = useState<Option[]>(
    []
  );
  const [userRoleOptions, setUserRoleOptions] = useState<Option[]>([]);
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  // Stats
  const [total, setTotal] = useState("0");
  const [newTotal, setNewTotal] = useState("0");
  const [totalMale, setTotalMale] = useState("0");
  const [totalFemale, setTotalFemale] = useState("0");
  const [totalIncomplete, setTotalIncomplete] = useState("0");
  const [incompleteUserIds, setIncompleteUserIds] = useState<number[]>([]);
  const [exitIncompleteUserIds, setExitIncompleteUserIds] = useState<number[]>([]);
  // const [saving,setSaving] = useState("0");

  // Modal/Form
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    dob: null as Date | string | null,
    joiningDate: null as Date | string | null,
    contact: "",
    gender: "",
    pan: "",
    photo: "",
    address: "",
    password: "",
    employmentStatus: "",
    leavingDate: null as Date | string | null,
    designation: "",
    reportingHead: "",
    userRole: "",
    bypassAttendance: false,
    permanentWfh: false,
    accountNumber: "",
    accountName: "",
    branchName: "",
    ifscCode: "",
    is_active:"",
  });
  const [formError, setFormError] = useState("");
  const [editId, setEditId] = useState<number | null>(null);
  const [modalMode, setModalMode] = useState<"add" | "edit">("add");
  const photoUrlRef = useRef<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const formatJoinDate = (d: string) => {
    const [day, month, year] = d.split("-");
    const names = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day}-${names[+month - 1]}-${year}`;
  };
  const emptyForm = {
    name: "",
    email: "",
    dob: "",
    contact: "",
    gender: "",
    pan: "",
    photo: "",
    address: "",
    password: "",
    employmentStatus: "",
    joiningDate: "",
    designation: "",
    reportingHead: "",
    userRole: "",
    leavingDate: "",
    bypassAttendance: false,
    permanentWfh: false,
    accountNumber: "",
    accountName: "",
    branchName: "",
    ifscCode: "",
    is_active:"",
  };

  const handleImageClick = (
    employeeId: string | number,
    employeeName: string
  ) => {
    navigate(`/profile/${employeeId}`, {
      state: {
        employeeName,
        previousUrl: "/employees",
        from: "employee",
      },
    });
  };

  // open modal (add or edit)
  const openModal = (mode: ModalMode, employee: EmployeeType | null = null) => {
    setModalMode(mode);

    if (mode === "add" && employee) {
      // setEditId(employee.id);
      setFormData(emptyForm);
      setFormErrors({});
      setEditId(null);
    }
    if (mode === "edit" && employee) {
      // setFormData({"" });
      setEditId(employee.id);
    }

    const modalElement = document.getElementById("employee-modal");
    if (modalElement) {
      const bsModal = new Modal(modalElement);
      bsModal.show();
    }
  };
  const openDeleteModal = (id: number) => {
    setEditId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };
  const handleCloseModal = () => {
    hideModal("employee-modal"); // hide the modal

    // Delay clearing to wait for modal transition (adjust timing if needed)
    setTimeout(() => {
      // Revoke the blob URL to prevent memory leak
      if (photoUrlRef.current) {
        URL.revokeObjectURL(photoUrlRef.current);
        photoUrlRef.current = null;
      }

      // Reset file input value
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setFormErrors({});
      setFormData(emptyForm);
      setEditId(null);
    }, 300); // 300ms = typical Bootstrap fade duration
  };

  const generatePassword = async () => {
    try {
      const res = await api<{ password: string }>(
        "/employees/generatepassword",
        {
          method: "GET",
        }
      );

      if (res.password) {
        setFormData((prev) => ({
          ...prev,
          password: res.password,
        }));
        toast.success("Password generated successfully!");
      } else {
        toast.error("Failed to generate password.");
      }
    } catch (error) {
      console.error("Password generation failed:", error);
      toast.error("Something went wrong while generating password.");
    }
  };

  const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el) return;
    const bsModal = Modal.getInstance(el) ?? new Modal(el);
    bsModal.hide();
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };
  const validateForm = () => {
    const errors: Record<string, string> = {};

    // Ensure all fields are properly checked before trimming
    if (!formData.name?.trim()) errors.name = "Name is required.";
    if (!formData.email?.trim()) errors.email = "Email is required.";
    //  else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
    //         errors.email = "Invalid email format.";
    //     }
    if (!formData.dob) errors.dob = "Date of Birth is required.";
    if (!formData.contact?.trim())
      errors.contact = "Contact Number is required.";
    else if (!/^\d{10}$/.test(formData.contact)) {
      errors.contact = "Phone number must be 10 digits.";
    }
    if (!formData.gender?.trim()) errors.gender = "Gender is required.";
    if (!formData.employmentStatus?.trim())
      errors.employmentStatus = "Employment Status is required.";

    console.log("Validation errors:", errors);
    // Check if reportingHead is a valid string
    // if (
    //   !formData.reportingHead ||
    //   typeof formData.reportingHead !== "string" ||
    //   !formData.reportingHead.trim()
    // ) {
    //   errors.reportingHead = "Reporting Head is required.";
    // }
    // if (
    //   !formData.designation ||
    //   typeof formData.designation !== "string" ||
    //   !formData.designation.trim()
    // ) {
    //   errors.designation = "Designation is required.";
    // }

    if (!formData.joiningDate)
      errors.joiningDate = "Date of Joining is required.";
    if (!formData.userRole?.trim()) errors.userRole = "User Role is required.";

    if (!formData.designation) errors.designation = "Designation is required.";
    if (!formData.reportingHead)
      errors.reportingHead = "Reporting Head is required.";
    if (
      (formData.employmentStatus === "3" || formData.employmentStatus === "4" || formData.employmentStatus === "6" ) &&
      !formData.leavingDate
    ) {
      errors.leavingDate = "Date of Leaving is required.";
    }
    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleRowClick = (record: {
    id: number;
    name: string;
    employee_image: string;
    designation: string;
    selectedUserId: number;
  }) => {
    const previousUrl = location.pathname + location.search;

    navigate(`/profile/${record.id}`, {
      state: {
        employeeName: record.name,
        employeeImage: record.employee_image,
        designation: record.designation,
        previousUrl,
        from: "employees",
        employeeId: record.id,
        selectedUserId: record.id,
      },
    });
  };

       // Define this near where you parse your joining date
  const joiningIso = dayjs(formData.joiningDate).format("YYYY-MM-DD");
  const isJoiningTodayOrFuture = dayjs(joiningIso).isSameOrAfter(dayjs().startOf('day'));

  const handleSubmit = async () => {
    console.log("handleSubmit called");

    if (!validateForm()) {
      console.log("Validation failed");
      return;
    }

    console.log("Validation passed", formData);
    // 1. Normalize your dates
    const dobIso = dayjs(formData.dob).format("YYYY-MM-DD");
    const joiningIso = dayjs(formData.joiningDate).format("YYYY-MM-DD");
    const leavingIso = dayjs(formData.leavingDate).format("YYYY-MM-DD");

    console.log("DOB Raw1:", formData.dob, "=> Parsed:", dobIso);
    console.log("DOJ Raw1:", formData.joiningDate, "=> Parsed:", joiningIso);
    // 2. Build FormData
    const payload = new FormData();
    payload.append("date_of_birth", dobIso);
    payload.append("date_of_joining", joiningIso);
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("phone_number", formData.contact);
    // map your gender value to whatever the API expects (e.g. "1" or "2")
    payload.append("gender", formData.gender === "male" ? "1" : "2");
    payload.append("pan_number", formData.pan);
    if (formData.photo) payload.append("photo", formData.photo);
    payload.append("address", formData.address);
    payload.append("status", formData.employmentStatus);
    payload.append("designation_id", formData.designation);
    payload.append("reporting_head", formData.reportingHead);
    payload.append("role_name", formData.userRole);
    if (isExitStatus(formData.employmentStatus)) {
      payload.append("date_of_leaving", leavingIso);
    }
    payload.append("password", formData.password);
    // these seem static in your example

    // When appending to the payload:
    if (isJoiningTodayOrFuture) {
        payload.append("is_active", "-1");
    } else {
        payload.append("is_active", formData.is_active ? "1" : "0");
    }

    payload.append("flag", "0");
    payload.append("account_number", formData.accountNumber);
    payload.append("account_name", formData.accountName);
    payload.append("branch_name", formData.branchName);
    payload.append("ifsc", formData.ifscCode);
    // boolean → "1"/"0"
    payload.append(
      "by_pass_attendance_check",
      formData.bypassAttendance ? "1" : "0"
    );
    payload.append("is_permenant_wfh", formData.permanentWfh ? "1" : "0");

    setIsSaving(true);
    try {
      // 3. Send the FormData
      const body: any = { title: formData.designation };
      if (modalMode === "edit" && editId != null) body.id = editId;
      const res: any = await api("/employees/saveEmployee", {
        method: "POST",
        body: payload,
      });
      setTotalItems((prevCount) => {
        const newCount = prevCount + 1;
        setCurrentPage(1);
        updateEmployeeFilterUrl({
          searchTerm,
          currentPage: 1,
          selectedDesignation,
          selectedStatus,
        });
        fetchEmployees();
        return newCount;
      });
      toast.success(res.message);
      hideModal("employee-modal");
      //   setFormData(emptyForm);
      //   setFormErrors({});
      //   setEditId(null);
      handleCloseModal();
      // fetchEmployees();
      // After adding a new employee, refresh onboarding stats
      // so the "Incomplete" count stays accurate.
      try {
        const statsRes = await nodeApi<{
          data: {
            total: number;
            new: number;
            male: number;
            female: number;
            incomplete: number;
            incompleteIds: number[];
            exitIncomplete: number;
            exitIncompleteIds: number[];
          };
        }>("/employee/onboarding/stats", { method: "GET" });
        const statsData = statsRes.data || ({} as any);
        setTotalIncomplete(String(statsData.incomplete ?? 0));
        setIncompleteUserIds(statsData.incompleteIds || []);
        setExitIncompleteUserIds(statsData.exitIncompleteIds || []);
      } catch (statsErr) {
        console.error("Failed to refresh onboarding stats after add:", statsErr);
      }
    } catch (err: any) {
      if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
        toast.error("The email Field must be a valid email address");
      }
      if (err.response?.data) {
        const data = err.response.data;
        const msg =
          data.error || data.message || err.message || "Something went wrong.";
        toast.error(msg);
      } else {
        toast.error(err.message || "Something went wrong.");
      }
    } finally {
      setIsSaving(false);
    }
  };

  const handleResetFilters = () => {
    setSearchTerm("");
    setSelectedDesignation("");
    setSelectedStatus("");
    setCurrentPage(1);
    // push a clean‐filters entry onto history
    navigate("/employees", { replace: false });
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await api<{ success: boolean; error?: string }>(
        `/employees/delete/${id}`,
        {
          method: "DELETE",
        }
      );

      if (res.success) {
        setDesignationsList((prev) => prev.filter((d) => d.id !== id));
        setTotalItems((prevCount) => prevCount - 1);
        toast.success("Employee deleted successfully!");
        // Calculate the total pages after deletion
        const totalPages = Math.ceil((totalItems - 1) / pageSize);
        // If the current page number is now greater than totalPages, move back one page
        if (currentPage > totalPages) {
          setCurrentPage(totalPages > 0 ? totalPages : 1);
          updateEmployeeFilterUrl({
            searchTerm,
            currentPage: totalPages > 0 ? totalPages : 1,
            selectedDesignation,
            selectedStatus,
          });
        } else {
          fetchEmployees();
        }
      } else {
        toast.error(res.error || "Failed to delete.");
      }
    } catch (err: any) {
      toast.error(err.message || "Employee Already Exists.");
    }
  };

  const handleEdit = (record: {
    id: number;
    name: string;
    employee_image: string;
    designation: string;
  }) => {
    const previousUrl = location.pathname + location.search;

    navigate(`/profile/${record.id}`, {
      state: {
        employeeName: record.name,
        employeeImage: record.employee_image,
        designation: record.designation,
        previousUrl,
        employeeId: record.id,
        selectedUserId: record.id,
      },
    });
  };

  //   navigate(`/profile/${employeeId}`, {
  //     state: { previousUrl: location.pathname }
  //   });
  // };

  const columns = [
   {
  title: "Name",
  dataIndex: "name",
  render: (_: any, rec: EmployeeType) => {
    const maxNameLength = 15;
    const maxDesignationLength = 20;

    const truncateText = (text: string, maxLength: number) =>
      text && text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;

        const isNoticePeriod = rec.status === "6";
        const isFinalizedExit = rec.status === "4"; // Terminated only — Released still needs the exit-incomplete indicator
        const isProfileIncomplete = incompleteUserIds.includes(rec.id);
        const isExitIncomplete = exitIncompleteUserIds.includes(rec.id);

    return (
      <div className="d-flex align-items-start">
        {rec.imageUrl && (
          <img
            src={rec.imageUrl}
            alt={rec.name}
            className="rounded-circle"
            style={{ width: 32, height: 32, objectFit: "cover" }}
          />
        )}
        <div className="ms-2" style={{ cursor: "pointer" }}>
          <h6 className="fw-medium" title={rec.name}>
            {truncateText(rec.name, maxNameLength)}
            {/* Show user exclamation mark if profile is incomplete */}
           {/*  Employee is in Notice Period (Status 6) */}
            {isExitIncomplete && !isFinalizedExit && (
              <i
                className="ti ti-alert-triangle text-warning ms-1"
                title="Exit Process Incomplete"
                style={{ fontSize: '14px' }}
              ></i>
            )}

            {/*  Standard Employee with Incomplete Profile */}
            {isProfileIncomplete && (
              <i
               className="ti ti-user-exclamation text-danger ms-1"
                title="Profile Incomplete"
                style={{
                  fontSize: '14px',
                //  border:'1px solid red', // Bootstrap 'danger' red
                //   borderRadius: '50%',
                //   padding: '4px',
                //   display: 'inline-flex',
                //   alignItems: 'center',
                //   justifyContent: 'center',
                //   width: '22px',
                //   height: '22px'
                }}
              ></i>
            )}

            {/* Terminated (Status 4) - No icon renders here; Released (3) still shows it while exit is incomplete */}
          </h6>
          <span
            className="fs-12 fw-normal"
            title={rec.designation?.title || "-"}
          >
            {truncateText(rec.designation?.title || "-", maxDesignationLength)}
          </span>
        </div>
      </div>
    );
  },
},
    {
      title: "E‑ID",
      dataIndex: "eId",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Contact No",
      dataIndex: "phoneNumber",
      render: (t: string) => {
        return t;
      },
    },
    {
    title: "Birth Date",
    dataIndex: "birthDate",
    render: (t: string) => {
        return t;
    },
  },
    {
      title: "Joining Date",
      dataIndex: "joinDate",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, rec: EmployeeType) => (
        <div className="action-icon d-inline-flex">
          {/* <Link to="#" onClick={() => handleEdit(rec.name)}>
            <i className="ti ti-edit" />
          </Link> */}
          <Link
            to="#"
            onClick={(e) => {
              e.stopPropagation(); //  Prevent row click
              openDeleteModal(rec.id);
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  const stats = [
    { title: "Total", value: total },
    { title: "New", value: newTotal },
    { title: "Male", value: totalMale },
    { title: "Female", value: totalFemale },
    { title: "Incomplete", value: totalIncomplete },
  ];

  //   const fetchFilterDropdownData = async () => {
  //   try {
  //     const res: any = await api("/get-filters-data", {
  //       method: "POST",
  //       body: { pageTitle: "employee" },
  //     });

  //     if (Array.isArray(res.designations)) {
  //       const baseOptions = res.designations.map((d: any) => ({
  //         label: d.title,
  //         value: d.id,
  //       }));
  //       setDesignationOptions([{ value: "", label: "All Designations" }, ...baseOptions]);
  //       setModalDesignationOptions(baseOptions);
  //     }

  //     if (res.status && typeof res.status === "object") {
  //       const baseOptions = Object.entries(res.status).map(([k, v]) => ({
  //         label: v as string,
  //         value: k,
  //       }));
  //       setStatusOptions([{ value: "", label: "All Active" }, ...baseOptions]);
  //       setModalStatusOptions(baseOptions);
  //     }

  //     if (Array.isArray(res.reporting_heads)) {
  //       setReportingHeadOptions(
  //         res.reporting_heads.map((head: any) => ({
  //           label: head.name,
  //           value: head.id,
  //           image: head.image_url,
  //         }))
  //       );
  //     }

  //     if (res.userrole && typeof res.userrole === "object") {
  //       setUserRoleOptions(
  //         Object.entries(res.userrole).map(([k, v]) => ({
  //           label: v as string,
  //           value: k,
  //         }))
  //       );
  //     }
  //   } catch (err: any) {
  //     console.error("Failed to load filters data:", err.message);
  //     toast.error("Failed to load filters");
  //   }
  // };

  // useEffect(() => {
  //   fetchFilterDropdownData();
  // }, []);

  useEffect(() => {
    if (filtersData && Object.keys(filtersData).length > 0) {
      const baseDesignationOptions = (filtersData?.designations || []).map(
        (d: any) => ({
          label: d.title,
          value: d.id,
        })
      );
      setDesignationOptions([
        { value: "", label: "All Designations" },
        ...baseDesignationOptions,
      ]);
      setModalDesignationOptions(baseDesignationOptions);

      if (
        filtersData.emp_status &&
        typeof filtersData.emp_status === "object"
      ) {
        const baseStatusOptions = Object.entries(filtersData.emp_status).map(
          ([k, v]) => ({
            label: String(v),
            value: k,
          })
        );
        setStatusOptions([
          { value: "", label: "All Active" },
          { value: "all", label: "All Status" },
          ...baseStatusOptions,
        ]);
        setModalStatusOptions(baseStatusOptions);
      }

      if (Array.isArray(filtersData.reporting_heads)) {
        setReportingHeadOptions(
          filtersData.reporting_heads.map((head: any) => ({
            label: head.name,
            value: head.id,
            image: head.image_url,
          }))
        );
      }

      if (filtersData.userrole && typeof filtersData.userrole === "object") {
        setUserRoleOptions(
          Object.entries(filtersData.userrole).map(([k, v]) => ({
            label: String(v),
            value: k,
          }))
        );
      }
    }
  }, [filtersData]);

 const fetchEmployees = async (searchOverride?: string) => {
  setLoading(true);
  try {
    const res: any = await api("/search-employee", {
      method: "POST",
      body: {
        currentPage,
        pageSize,
        designation:
          selectedDesignation !== "" ? selectedDesignation : undefined,
        status: selectedStatus !== "" ? selectedStatus : undefined,
        search: (searchOverride ?? searchTerm) || undefined,
      },
    });

    const employeeData = Array.isArray(res.data) ? res.data : [];

    const transformedList = employeeData.map((rec: any) => ({
      id: rec.id,
      imageUrl: rec.image_url ?? "",
      name: rec.name ?? "N/A",
      designation: { title: rec.designation?.title ?? "N/A" },
      eId: rec.employee_id ?? "—",
      phoneNumber: rec.phone_number ?? "—",
      joinDate: formatJoinDate(rec.date_of_joining),
      birthDate: formatJoinDate(rec.date_of_birth),
      isOnboardingComplete: rec.is_onboarding_complete,
      isExitComplete: rec.is_exit_process_complete, // Map the exit completion key
      status: String(rec.status), // Store status as a string for comparison
    }));

    setDesignationsList(transformedList);
    setTotal(res.total_employee?.toString() || "0");
    setNewTotal(res.new_employee?.toString() || "0");
    setTotalMale(res.total_male?.toString() || "0");
    setTotalFemale(res.total_female?.toString() || "0");
    setTotalItems(res.pagination.total || 0);
  } catch (err: any) {
    console.error("Fetch error:", err.message);
    setDesignationsList([]);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  userInitiatedSearchRef.current = false;
  setFiltersReady(false); // temporarily block fetchEmployees

  const [, , encoded] = location.pathname.split("/");
  if (encoded) {
    try {
      const { searchTerm, currentPage, selectedDesignation, selectedStatus } =
        decryptQuery(decodeURIComponent(encoded)) as EmployeeFiltersQuery;

      setSearchTerm(searchTerm || "");
      setCurrentPage(currentPage ?? 1);
      setSelectedDesignation(selectedDesignation ?? "");
      setSelectedStatus(selectedStatus ?? "");
    } catch {
      setSearchTerm("");
      setCurrentPage(1);
      setSelectedDesignation("");
      setSelectedStatus("");
    }
  } else {
    setSearchTerm("");
    setCurrentPage(1);
    setSelectedDesignation("");
    setSelectedStatus("");
  }

  // Delay setting filtersReady to next tick after all setStates
  setTimeout(() => {
    setFiltersReady(true);
  }, 0);
}, [location.pathname]);


useEffect(() => {
  if (!filtersReady || isInitialFetch.current) {
    isInitialFetch.current = false;
    // Load overall onboarding stats once when filters are ready
    fetchOnboardingStats();
    return;
  }

  fetchEmployees();
}, [
  currentPage,
  pageSize,
  selectedDesignation,
  selectedStatus,
  filtersReady, // Removed debouncedSearchTerm here
]);



  const defaultEmployeeFilters: EmployeeFiltersQuery = {
    searchTerm: "",
    currentPage: 1,
    selectedDesignation: "",
    selectedStatus: "",
  };

  const areEmployeeFiltersDefault = (filters: EmployeeFiltersQuery) => {
    return (
      (!filters.searchTerm || filters.searchTerm.trim() === "") &&
      (filters.currentPage ?? 1) === defaultEmployeeFilters.currentPage &&
      (filters.selectedDesignation ?? "") ===
        defaultEmployeeFilters.selectedDesignation &&
      (filters.selectedStatus ?? "") === defaultEmployeeFilters.selectedStatus
    );
  };

  const updateEmployeeFilterUrl = (
    filters: EmployeeFiltersQuery,
    baseRoute = "/employees"
  ) => {
    if (areEmployeeFiltersDefault(filters)) {
      navigate(baseRoute, { replace: false });
    } else {
      const encrypted = encryptQuery(filters);
      const encoded = encodeURIComponent(encrypted);
      navigate(`${baseRoute}/${encoded}`, { replace: false });
    }
  };

  const handleSearchChange = (val: string) => {
  userInitiatedSearchRef.current = true;
  setSearchTerm(val);
  setCurrentPage(1);

  if (debounceTimeoutRef.current) {
    clearTimeout(debounceTimeoutRef.current);
  }

  debounceTimeoutRef.current = setTimeout(() => {
    const trimmed = val.trim();

    updateEmployeeFilterUrl({
  searchTerm: val,
  currentPage: 1,
  selectedDesignation,
  selectedStatus,
});

    // Trigger only one API call with full payload (search + filters)
    fetchEmployees(val);
  }, 500);
};

  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  // useEffect(() => {
  //   const minLength = 3;
  //   const trimmed = debouncedSearchTerm.trim();
  //   const isValidSearch = trimmed.length >= minLength || trimmed === "";

  //   if (!isValidSearch || !userInitiatedSearchRef.current) return;

  //   updateEmployeeFilterUrl({
  //     searchTerm: trimmed,
  //     currentPage: 1,
  //     selectedDesignation,
  //     selectedStatus,
  //   });

  //   setCurrentPage(1); // reset page
  // }, [debouncedSearchTerm]);

  const handleDesignationChange = (opt: Option | null) => {
    const val = opt?.value ?? "";
    setSelectedDesignation(val);
    setCurrentPage(1);
    updateEmployeeFilterUrl({
      searchTerm,
      currentPage: 1,
      selectedDesignation: val,
      selectedStatus,
    });
  };

  const handleStatusChange = (opt: Option | null) => {
    const val = opt?.value ?? "";
    setSelectedStatus(val);
    setCurrentPage(1);
    updateEmployeeFilterUrl({
      searchTerm,
      currentPage: 1,
      selectedDesignation,
      selectedStatus: val,
    });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    updateEmployeeFilterUrl({
      searchTerm,
      currentPage: page,
      selectedDesignation,
      selectedStatus,
    });
  };
  // useEffect(() => {
  //   const filtersAreDefault =
  //     (debouncedSearchTerm || "").trim() === "" &&
  //     (selectedDesignation === null || selectedDesignation === "") &&
  //     (selectedStatus === null || selectedStatus === "") &&
  //     currentPage === 1;

  //   const filters: EmployeeFiltersQuery = {
  //     searchTerm: debouncedSearchTerm.trim(),
  //     currentPage,
  //     selectedDesignation,
  //     selectedStatus,
  //   };

  //   if (filtersAreDefault) {
  //     navigate("/employees", { replace: true });
  //   } else {
  //     updateEmployeeFilterUrl(filters);
  //   }
  // }, [debouncedSearchTerm, currentPage, selectedDesignation, selectedStatus]);

  const filtersNode = useMemo(
    () => (
      <EmployeeFilters
        searchTerm={searchTerm}
        onSearchTermChange={handleSearchChange}
        designationOptions={designationOptions}
        selectedDesignation={selectedDesignation}
        onDesignationChange={handleDesignationChange}
        statusOptions={statusOptions}
        selectedStatus={selectedStatus}
        onStatusChange={handleStatusChange}
        onAdd={() => openModal("add")}
        onResetFilters={handleResetFilters}
      />
    ),
    [
      searchTerm,
      designationOptions,
      selectedDesignation,
      statusOptions,
      selectedStatus,
    ]
  );

  // Fetch global onboarding stats (Total/New/Male/Female/Incomplete)
  const fetchOnboardingStats = async () => {
    try {
      const res = await nodeApi<{
        data: { total: number; new: number; male: number; female: number; incomplete: number; incompleteIds: number[]; exitIncomplete: number; exitIncompleteIds: number[] };
      }>("/employee/onboarding/stats", { method: "GET" });

      const statsData = res.data || ({} as any);
      setTotalIncomplete(String(statsData.incomplete ?? 0));
      setIncompleteUserIds(statsData.incompleteIds || []);
      setExitIncompleteUserIds(statsData.exitIncompleteIds || []);
    } catch (error) {
      console.error("Failed to load onboarding stats:", error);
    }
  };

  useEffect(() => {
    setFilters(filtersNode);
    return () => {
      setFilters(null);
    };
  }, [filtersNode]);

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  return (
    <>
      <HeaderFilterProvider>
        <div className="page-wrapper d-flex flex-column">
          <div className="content flex-grow-1">
            <div className="row custom-att-boxes">
              {stats.map((item, i) => (
                <div key={i} className="col-lg-3 col-3">
                  <div className="card flex-fill att-card">
                    <div className="card-body d-flex align-items-center justify-content-between box-padding">
                      <div className="d-flex align-items-center overflow-hidden">
                        <div>
                          <p className="fs-16 mb-1 text-truncate att-boxes-title att-female-ellipsis">
                            {item.title}
                          </p>
                          <h3 className="mb-0 att-boxes-value">{item.value}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* Add/Edit Employee Modal */}
            <div id="employee-modal" className="modal fade" tabIndex={-1}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4 className="modal-title">
                      {modalMode === "edit" ? "Edit" : "Add"} Employee
                    </h4>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleCloseModal}
                    />
                  </div>
                  <div className="modal-body">
                    {/* Personal Details */}
                    <h5 className="mb-3">Personal Details</h5>
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label>
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.name}
                          onChange={(e) => {
                            setFormData({ ...formData, name: e.target.value });
                            if (formErrors.name)
                              setFormErrors({ ...formErrors, name: "" });
                          }}
                        />
                        {formErrors.name && (
                          <div style={{ color: "red" }}>{formErrors.name}</div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={formData.email}
                          onChange={(e) => {
                            setFormData({ ...formData, email: e.target.value });
                            if (formErrors.email)
                              setFormErrors({ ...formErrors, email: "" });
                          }}
                        />
                        {formErrors.email && (
                          <div style={{ color: "red" }}>{formErrors.email}</div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>
                          Date of Birth<span className="text-danger">*</span>
                        </label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker ps-15"
                            value={
                              formData.dob
                                ? dayjs(formData.dob, "YYYY-MM-DD")
                                : null
                            }
                            format="DD-MMM-YYYY"
                            placeholder="DD-MMM-YYYY"
                            disabledDate={(current) =>
                              current && current.isSameOrAfter(dayjs(), "day")
                            }
                            onChange={(date) => {
                              setFormData((prev) => ({
                                ...prev,
                                dob: date ? date.format("YYYY-MM-DD") : "",
                              }));
                              if (formErrors.dob) {
                                setFormErrors((prev) => ({
                                  ...prev,
                                  dob: "",
                                }));
                              }
                            }}
                          />

                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                        {formErrors.dob && (
                          <div style={{ color: "red" }}>{formErrors.dob}</div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>
                          Contact<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.contact}
                          maxLength={10}
                          onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, ""); // only digits
                            setFormData({ ...formData, contact: input });
                            if (formErrors.contact)
                              setFormErrors({ ...formErrors, contact: "" });
                          }}
                        />
                        {formErrors.contact && (
                          <div style={{ color: "red" }}>
                            {formErrors.contact}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>
                          Gender<span className="text-danger">*</span>
                        </label>
                        <CommonSelect
                          className="Select"
                          placeholder="Select Gender"
                          isFullWidth={true}
                          isOpenModalMargin={true}
                          forceFullWidth={true}
                          isHeight={true}
                          isMulti={false}
                          options={genderOptions}
                          value={
                            genderOptions.find(
                              (opt) => opt.value === formData.gender
                            ) || null
                          }
                          onChange={(opt) => {
                            setFormData({
                              ...formData,
                              gender: opt ? opt.value : "",
                            });
                            if (formErrors.gender)
                              setFormErrors({ ...formErrors, gender: "" });
                          }}
                        />
                        {formErrors.gender && (
                          <div style={{ color: "red" }}>
                            {formErrors.gender}
                          </div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>PAN Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.pan}
                          onChange={(e) =>
                            setFormData({ ...formData, pan: e.target.value })
                          }
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>Photo</label>
                        <input
                          type="file"
                          className="form-control"
                          ref={fileInputRef}
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                              // Revoke previous URL if exists
                              if (photoUrlRef.current) {
                                URL.revokeObjectURL(photoUrlRef.current);
                              }
                              const newUrl = URL.createObjectURL(file);
                              photoUrlRef.current = newUrl;
                              setFormData({
                                ...formData,
                                photo: newUrl,
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>Address</label>
                        <textarea
                          className="form-control"
                          value={formData.address}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              address: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    {/* Professional Details */}
                    <h5 className="mb-3">Professional Details</h5>
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label>
                          Employment Status
                          <span className="text-danger">*</span>
                        </label>
                        <CommonSelect
                          className="select"
                          placeholder="Select Status"
                          isFullWidth={true}
                          forceFullWidth={true}
                          // isOpenModal={true}
                          isOpenModalMargin={true}
                          isHeight={true}
                          options={modalStatusOptions}
                          value={modalStatusOptions.find(
                            (opt) => opt.value === formData.employmentStatus
                          )}
                          onChange={(opt) => {
                            // update value
                            setFormData((prev) => ({
                              ...prev,
                              employmentStatus: opt ? opt.value : "",
                            }));
                            // clear error if it was present
                            if (formErrors.employmentStatus) {
                              setFormErrors((prev) => ({
                                ...prev,
                                employmentStatus: "",
                              }));
                            }
                          }}
                        />
                        {formErrors.employmentStatus && (
                          <div style={{ color: "red", marginTop: "4px" }}>
                            {formErrors.employmentStatus}
                          </div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>
                          Joining Date<span className="text-danger">*</span>
                        </label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker ps-15"
                            value={
                              formData.joiningDate
                                ? dayjs(formData.joiningDate)
                                : null
                            }
                            format="DD-MMM-YYYY"
                            placeholder="DD-MMM-YYYY"
                            onChange={(date) => {
                              setFormData((prev) => ({
                                ...prev,
                                joiningDate: date
                                  ? date.format("YYYY-MM-DD")
                                  : "",
                              }));
                              if (formErrors.joiningDate) {
                                setFormErrors((prev) => ({
                                  ...prev,
                                  joiningDate: "",
                                }));
                              }
                            }}
                          />
                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                        {formErrors.joiningDate && (
                          <div style={{ color: "red", marginTop: "4px" }}>
                            {formErrors.joiningDate}
                          </div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3 ">
                        <label>
                          Designation<span className="text-danger">*</span>
                        </label>
                        <CommonSelect
                          className="select"
                          placeholder="Select Designation"
                          isFullWidth={true}
                          // isOpenModal={true}
                          forceFullWidth={true}
                          isOpenModalMargin={true}
                          isHeight={true}
                          options={modalDesignationOptions}
                          value={modalDesignationOptions.find(
                            (opt) => opt.value === formData.designation
                          )}
                          onChange={(opt) => {
                            setFormData((prev) => ({
                              ...prev,
                              designation: opt ? opt.value : "",
                            }));
                            // clear error if it was present
                            if (formErrors.designation) {
                              setFormErrors((prev) => ({
                                ...prev,
                                designation: "",
                              }));
                            }
                          }}
                        />
                        {formErrors.designation && (
                          <div style={{ color: "red", marginTop: "4px" }}>
                            {formErrors.designation}
                          </div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>
                          Reporting Head<span className="text-danger">*</span>
                        </label>
                        <CommonSelect
                          className="select"
                          placeholder="Select Reporting Head"
                          isFullWidth={true}
                          forceFullWidth={true}
                          // isOpenModal={true}
                          isOpenModalMargin={true}
                          isHeight={true}
                          options={reportingHeadOptions}
                          value={reportingHeadOptions.find(
                            (opt) => opt.value === formData.reportingHead
                          )}
                          onChange={(opt) => {
                            setFormData((prev) => ({
                              ...prev,
                              reportingHead: opt ? opt.value : "",
                            }));
                            // clear error if it was present
                            if (formErrors.reportingHead) {
                              setFormErrors((prev) => ({
                                ...prev,
                                reportingHead: "",
                              }));
                            }
                          }}
                        />
                        {formErrors.reportingHead && (
                          <div style={{ color: "red", marginTop: "4px" }}>
                            {formErrors.reportingHead}
                          </div>
                        )}
                      </div>
                      {isExitStatus(formData.employmentStatus) && (
                        <div className="col-md-3 mb-3">
                          <label>
                            Date of leaving
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker ps-15"
                              value={
                                formData.leavingDate
                                  ? dayjs(formData.leavingDate)
                                  : null
                              }
                              format="DD-MMM-YYYY"
                              placeholder="DD-MMM-YYYY"
                              onChange={(date) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  leavingDate: date
                                    ? date.format("YYYY-MM-DD")
                                    : "",
                                }));
                                if (formErrors.leavingDate) {
                                  setFormErrors((prev) => ({
                                    ...prev,
                                    leavingDate: "",
                                  }));
                                }
                              }}
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                          {formErrors.leavingDate && (
                            <div style={{ color: "red", marginTop: "4px" }}>
                              {formErrors.leavingDate}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label>
                          User Role<span className="text-danger">*</span>
                        </label>
                        <CommonSelect
                          className="select"
                          placeholder="Select Role"
                          isFullWidth={true}
                          forceFullWidth={true}
                          // isOpenModal={true}
                          isOpenModalMargin={true}
                          isHeight={true}
                          options={userRoleOptions}
                          value={userRoleOptions.find(
                            (opt) => opt.value === formData.userRole
                          )}
                          onChange={(opt) => {
                            // update the value
                            setFormData((prev) => ({
                              ...prev,
                              userRole: opt ? opt.value : "",
                            }));
                            // clear any existing error
                            if (formErrors.userRole) {
                              setFormErrors((prev) => ({
                                ...prev,
                                userRole: "",
                              }));
                            }
                          }}
                        />
                        {formErrors.userRole && (
                          <div style={{ color: "red", marginTop: "4px" }}>
                            {formErrors.userRole}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label>Password</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            value={formData.password || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                password: e.target.value,
                              })
                            }
                          />
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={generatePassword}
                          >
                            Generate
                          </button>
                        </div>
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Bypass Attendance</label>
                        <div className="form-check mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="bypassAttendance"
                            checked={formData.bypassAttendance}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                bypassAttendance: e.target.checked,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="bypassAttendance"
                          >
                            Check
                          </label>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>Permanent WFH</label>
                        <div className="form-check mt-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="permanentWfh"
                            checked={formData.permanentWfh}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                permanentWfh: e.target.checked,
                              })
                            }
                          />
                          <label
                            className="form-wfh-label"
                            htmlFor="permanentWfh"
                          >
                            WFH
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Bank Details */}
                    <h5 className="mb-3">Bank Details</h5>
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label>Account Number</label>
                        <input
                          type="text"
                          // maxLength={10}
                          className="form-control"
                          value={formData.accountNumber}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              accountNumber: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>Account Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.accountName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              accountName: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>Branch Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.branchName}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              branchName: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>IFSC</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.ifscCode}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              ifscCode: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={isSaving}
                    >
                      {isSaving ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card card-margin-bottom">
              <div
                className="card-body p-0"
                id="Designation-list"
                style={{
                  height: tableHeight,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Table
                  style={{ flex: 1 }}
                  dataSource={
                    Array.isArray(designationsList) ? designationsList : []
                  }
                  columns={columns}
                  onRowClick={handleRowClick}
                  rowClassName={() => "clickable-row"}
                  onPageChange={handlePageChange}
                  totalItems={totalItems}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  loading={loading}

                  // onRowClick={handleRowClick}
                />
              </div>
            </div>
          </div>

          {/* Delete Confirmation Modal */}
          <div id="top-modal" className="modal fade" tabIndex={-1}>
            <div className="modal-dialog modal-top">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Delete</h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this record?</p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-cancel" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      if (editId !== null) handleDelete(editId);
                    }}
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="footer">
            <Footer />
          </div>
        </div>
      </HeaderFilterProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Employees;
